module.exports = __webpack_public_path__ + "1.5.0-unryo/img/mongodb.2985235d.svg";